/**
 * Super simple local check: if page is running in a frame,
 *   it "most likely" is platform-controlled
 */
export var useFastPlatformCheck = function useFastPlatformCheck() {
  return typeof window !== 'undefined' && window.parent !== window;
};